export const settingsList = (state) => state.settingsList;

export const loadingSettings = (state) => state.loadingSettings;

export const getFieldFromSettings = (state) => (field) => state.loadingSettings.filter(x => x.parameter === field)[0];
